import { render } from "./EmptyStateCard.vue?vue&type=template&id=b9fae7b6"
const script = {}

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__